var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Input, Button, Heading2 } from "@stellar/design-system";
import { BUSINESS_SERVER_ENDPOINT } from "App";
export var Kyc = function (_a) {
    var sessionToken = _a.sessionToken, type = _a.type, callback = _a.callback;
    var _b = useState({
        deposit: {
            amount: "",
            name: "",
            surname: "",
            email: "",
        },
        withdrawal: {
            amount: "",
            name: "",
            surname: "",
            email: "",
            bank: "",
            account: "",
        },
    }), kycFields = _b[0], setKycFields = _b[1];
    // TODO: update any type
    var handleChangeValue = function (e) {
        if (!type) {
            return;
        }
        setKycFields(function (prevState) {
            var _a, _b;
            return (_a = {},
                _a[type] = __assign(__assign({}, prevState[type]), (_b = {}, _b[e.target.name] = e.target.value, _b)),
                _a);
        });
    };
    // TODO: update any type
    var handleSubmitKyc = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var response, sessionId, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!type) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch("".concat(BUSINESS_SERVER_ENDPOINT, "/submit"), {
                            method: "POST",
                            headers: {
                                Authorization: "Bearer ".concat(sessionToken),
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(kycFields[type]),
                        })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    sessionId = (_a.sent()).sessionId;
                    callback(sessionId);
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    // TODO: handle error
                    console.log(e_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var renderDepositFields = function () {
        var _a, _b, _c, _d;
        return (_jsxs(_Fragment, { children: [_jsx(Heading2, { children: "Deposit" }), _jsx(Input, { label: "Amount", id: "amount", name: "amount", value: ((_a = kycFields.deposit) === null || _a === void 0 ? void 0 : _a.amount) || "", onChange: handleChangeValue, required: true }), _jsx(Input, { label: "First name", id: "name", name: "name", value: ((_b = kycFields.deposit) === null || _b === void 0 ? void 0 : _b.name) || "", onChange: handleChangeValue, required: true }), _jsx(Input, { label: "Last name", id: "surname", name: "surname", value: ((_c = kycFields.deposit) === null || _c === void 0 ? void 0 : _c.surname) || "", onChange: handleChangeValue, required: true }), _jsx(Input, { label: "Email", id: "email", name: "email", type: "email", value: ((_d = kycFields.deposit) === null || _d === void 0 ? void 0 : _d.email) || "", onChange: handleChangeValue, required: true })] }));
    };
    var renderWithdrawFields = function () {
        var _a, _b, _c, _d, _e, _f;
        return (_jsxs(_Fragment, { children: [_jsx(Heading2, { children: "Withdrawal" }), _jsx(Input, { label: "Amount", id: "amount", name: "amount", value: ((_a = kycFields.withdrawal) === null || _a === void 0 ? void 0 : _a.amount) || "", onChange: handleChangeValue, required: true }), _jsx(Input, { label: "First name", id: "name", name: "name", value: ((_b = kycFields.withdrawal) === null || _b === void 0 ? void 0 : _b.name) || "", onChange: handleChangeValue, required: true }), _jsx(Input, { label: "Last name", id: "surname", name: "surname", value: ((_c = kycFields.withdrawal) === null || _c === void 0 ? void 0 : _c.surname) || "", onChange: handleChangeValue, required: true }), _jsx(Input, { label: "Email", id: "email", name: "email", type: "email", value: ((_d = kycFields.withdrawal) === null || _d === void 0 ? void 0 : _d.email) || "", onChange: handleChangeValue, required: true }), _jsx(Input, { label: "Bank", id: "bank", name: "bank", value: ((_e = kycFields.withdrawal) === null || _e === void 0 ? void 0 : _e.bank) || "", onChange: handleChangeValue, required: true }), _jsx(Input, { label: "Account", id: "account", name: "account", value: ((_f = kycFields.withdrawal) === null || _f === void 0 ? void 0 : _f.account) || "", onChange: handleChangeValue, required: true })] }));
    };
    if (!type) {
        return _jsx("div", { children: "Loading..." });
    }
    return (_jsxs("form", __assign({ className: "FormContainer", onSubmit: handleSubmitKyc }, { children: [type === "deposit" ? renderDepositFields() : null, type === "withdrawal" ? renderWithdrawFields() : null, _jsx(Button, __assign({ type: "submit" }, { children: "Submit" }))] })));
};
